<template>
  <div class="w-full relative">
    <jet-label for="time_zone" value="Timezone" />
    <!-- <GlobeIcon class="globe-icon"></GlobeIcon> -->
    <select
      :value="selectedTimezone"
      data-cy="session-timezone"
      id="timezone"
      @change="changeTimezone"
      class="
        mt-1
        block
        w-full
        border-gray-300
        focus:ring-vice-teal-500
        focus:border-vice-teal-500
        rounded-md
        shadow-sm
        sm:text-sm
        text-gray-900
        timezone-select
      "
    >
      <option
        v-for="tz in timezones"
        :selected="selectedTimezone === tz.value"
        v-bind:value="tz.value"
        :key="tz.value"
      >
        {{ tz.label }}
      </option>
    </select>
  </div>
</template>
<script>
import { listTz } from 'timezone-select-js';
import JetLabel from '@/Jetstream/Label.vue';
// import GlobeIcon from '@/Components/Icons/GlobeIcon.vue';

export default {
  name: 'TimeZoneSelect',
  components: {
    JetLabel,
    // GlobeIcon,
  },
  emits: ['timezoneChanged'],
  props: {
    selectedTimezone: {
      required: true,
    },
  },
  setup(_, { emit }) {
    let previousTimezone;
    const timezones = listTz();

    const changeTimezone = (e) => {
      previousTimezone = e.target.value;
      if (previousTimezone) emit('timezoneChanged', previousTimezone);
    };

    return {
      timezones,
      changeTimezone,
    };
  },
};
</script>
<style scoped>
/* .globe-icon {
  position: absolute;
  z-index: 10;
  top: 33px;
  left: 10px;
}

.timezone-select {
  padding-left: 35px;
} */
</style>
